import React from "react";
import Crypto from "./crypto";
import Giftcard from "./giftcard";
import { Tabs } from "antd";

const items = [
  {
    key: "1",
    label: "Crypto",
    children: <Crypto />,
  },
  {
    key: "2",
    label: "Gift Card",
    children: <Giftcard />,
  },
];

const TradeHistory = () => {
  return (
    <div>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};

export default TradeHistory;
